import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import CSSModules from 'react-css-modules';
import HappyFace from '@client/components/shared/faces/HappyFace';
import Translate from '@client/components/shared/translation/Translate';

import styles from './resetPasswordContent.scss';

export class ResetPasswordContent extends PureComponent {
    static propTypes = {
        closeOverlay: PropTypes.func.isRequired,
    };

    render() {
        return (
            <div styleName="container">
                <div styleName="icon">
                    <HappyFace />
                </div>
                <div styleName="content">
                    <h2>
                        <Translate message="title" />
                    </h2>
                    <div styleName="message">
                        <p>
                            <Translate message="message" />
                        </p>
                        <a auto-tests="auto-tests-reset-password-success-close" href="#" onClick={this.handleClose}>
                            <Translate message="cta" />
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    handleClose = ev => {
        ev.preventDefault();
        this.props.closeOverlay();
    };
}

export default CSSModules(ResetPasswordContent, styles);
